
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { TimeRange } from '@/hooks/useTimeRange';

interface UsageComparisonChartProps {
  timeRange: TimeRange;
}

const UsageComparisonChart: React.FC<UsageComparisonChartProps> = ({ timeRange }) => {
  // Sample comparison data (current vs previous period)
  const getComparisonData = () => {
    if (timeRange === 'month') {
      return [
        { name: 'Week 1', current: 320, previous: 280 },
        { name: 'Week 2', current: 300, previous: 310 },
        { name: 'Week 3', current: 340, previous: 300 },
        { name: 'Week 4', current: 280, previous: 290 },
      ];
    } else if (timeRange === 'quarter') {
      return [
        { name: 'Month 1', current: 950, previous: 880 },
        { name: 'Month 2', current: 920, previous: 940 },
        { name: 'Month 3', current: 980, previous: 900 },
      ];
    } else {
      return [
        { name: 'Q1', current: 2800, previous: 2650 },
        { name: 'Q2', current: 3100, previous: 2900 },
        { name: 'Q3', current: 3500, previous: 3200 },
        { name: 'Q4', current: 2900, previous: 2750 },
      ];
    }
  };

  const data = getComparisonData();

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip 
          formatter={(value) => [`${value} kWh`, '']}
          contentStyle={{
            borderRadius: '8px',
            border: 'none',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            backgroundColor: 'rgba(255, 255, 255, 0.97)'
          }}
        />
        <Legend />
        <Bar dataKey="current" name="Current Period" fill="#8B5CF6" radius={[4, 4, 0, 0]} />
        <Bar dataKey="previous" name="Previous Period" fill="#D946EF" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default UsageComparisonChart;
